// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#onboarding-reminder[data-v-158432e7]{padding:20px;background-color:rgba(44,109,255,.14);border-radius:5px}#onboarding-reminder p[data-v-158432e7]{margin:0}#onboarding-reminder p a[data-v-158432e7]{color:#007bff !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
